const SCRIPT_ID = 'property-google-tag-manager';
const NOSCRIPT_ID = 'property-google-tag-manager-noscript';

export const isGoogleTagManagerTrackingId = (trackingId) =>
  /^GTM-[A-Z0-9]+$/i.test(trackingId?.trim() ?? '');

const isProductionPortal = () =>
  process.env.REACT_APP_NODE_ENV === 'production';

const getGoogleTagManagerScript = (trackingId) =>
  `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${trackingId}');`;

export const installGoogleTagManager = (trackingId) => {
  if (!isProductionPortal() || !isGoogleTagManagerTrackingId(trackingId)) {
    return;
  }

  const normalizedTrackingId = trackingId.trim();

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.textContent = getGoogleTagManagerScript(normalizedTrackingId);
    document.head.prepend(script);
  }

  if (!document.getElementById(NOSCRIPT_ID)) {
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${normalizedTrackingId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    const noscript = document.createElement('noscript');
    noscript.id = NOSCRIPT_ID;
    noscript.appendChild(iframe);
    document.body.prepend(noscript);
  }
};
